<template>
  <v-card-actions class="mt-3">
    <v-btn
      v-if="editing && !hideDelete"
      class="ml-4"
      color="softRed"
      :small="$vuetify.breakpoint.smAndDown"
      :disabled="loading"
      @click="$emit('delete')"
    >
      {{ $t('common.delete') }}
    </v-btn>
    <v-spacer />
    <v-btn
      class="mr-1"
      text
      :disabled="loading"
      :small="$vuetify.breakpoint.smAndDown"
      @click="$emit('cancel')"
    >
      {{ $t('common.cancel') }}
    </v-btn>
    <v-btn
      color="primary"
      :loading="loading"
      :small="$vuetify.breakpoint.smAndDown"
      :disabled="saveDisabled"
      @click="$emit('save')"
    >
      {{ saveText }}
    </v-btn>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    saveText: {
      type: String,
      default: 'OK',
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
    hideDelete: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
